import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ParksModule } from '@spaq/modules/parks';
import { PaymentModule } from '@spaq/modules/payment';
import { ServicesModule } from '@spaq/modules/services';
import { SubscriptionModule } from '@spaq/modules/subscription';
import { UserModule } from '@spaq/modules/user';
import { UtilsModule } from '@spaq/modules/utils';
import { VehiclesModule } from '@spaq/modules/vehicles';
import { FormModule } from '@spaq/shared/components/forms';
import { SharedCommonModule, SharedComponentsModule, SharedFormModule } from '@spaq/shared';
import { TranslateModule } from '@ngx-translate/core';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IntlModule } from '@progress/kendo-angular-intl';
import { UploadModule } from '@progress/kendo-angular-upload';
import { NgxMdModule } from 'ngx-md';
import { ContactFormComponent } from './components';
import { ContactWarningComponent } from './components/contact-warning.component';
import { ContactPageComponent } from './pages';
import { ContractModule } from '@spaq/modules/contract';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

export const routes = [{ path: '', component: ContactPageComponent }];

@NgModule({
	declarations: [ContactPageComponent, ContactFormComponent, ContactWarningComponent],
	exports: [ContactPageComponent, ContactFormComponent],
	imports: [
		SharedCommonModule,
		SharedComponentsModule,
		HttpClientModule,
		ParksModule,
		ServicesModule,
		TranslateModule,
		DropDownsModule,
		SubscriptionModule,
		VehiclesModule,
		PaymentModule,
		UserModule,
		DateInputsModule,
		IntlModule,
		RouterModule.forChild(routes),
		SharedComponentsModule,
		UtilsModule,
		NgxMdModule,
		UploadModule,
		FormModule,
		SharedFormModule,
		ContractModule,
		TooltipModule
	]
})
export class ContactModule {}
